import React from "react";
import {
  Box,
  FormControlLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Switch } from "@thekilroygroup/shared-ui";

interface IProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const YouthStudentSwitch = (props: IProps) => {
  const { label, checked, onChange } = props;
  const theme = useTheme();
  const labelPlacement = useMediaQuery(theme.breakpoints.up("sm"))
    ? "end"
    : "start";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: { xs: "end", sm: "start" },
      }}
    >
      <FormControlLabel
        control={<Switch checked={checked} onChange={onChange} />}
        label={
          <Typography variant="titleExtraSmall" weight="bold">
            {label}
          </Typography>
        }
        labelPlacement={labelPlacement}
        sx={{
          gap: 1,
          m: 0,
          mt: 2,
        }}
      />
    </Box>
  );
};
